<template>
    <div class="text-xs-center">
        <div>


            <div v-if="loading">

                <h3><v-progress-circular
                        class="mr-1"
                        indeterminate
                        color="primary"
                ></v-progress-circular> Loading...</h3>
            </div>

            <qrcode-stream class="element" @decode="onDecode" @init="onInit"/>
            <p class="error">{{ error }}</p>
            <!--<p class="decode-result">Last result: <b>{{ result }}</b></p>-->

        </div>
    </div>

</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader'
    import EventBus from '@/EventBus'
    export default {

        components: { QrcodeStream },

        data () {
            return {
                loading:false,
                result: '',
                error: '',
                camera: 'auto'
            }
        },
        mounted(){
            window.scrollTo(0,0)
            EventBus.$emit('set_navigation', {title:'SCAN QR CODE',back_route:'home'})
        },
        watch:{
            result(){
                // window.open(this.result,"_blank")
                if(this.result.includes("?")){
                    EventBus.$emit('set_navigation', {title:'ประเมิน',back_route:'home'})
                    this.$router.push(`/eval?${this.result.split('?')[1]}`)
                }else{
                    console.log('โถถัง!')
                    this.error = 'กรุณาตรวจสอบ QR CODE'
                }

            }
        },
        methods: {

            onDecode (result) {
                this.result = result
            },
            back_to_emp(){
                this.$emit('back_to_emp')
            },
            async onInit (promise) {
                this.loading = true
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    } else {
                        this.error = error.name
                    }
                } finally {
                    this.loading = false
                }
            }
        }
    }
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: white;
    }
</style>